import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../stories/Icon';

interface FindLiveClassButtonProps {
  onClick?: () => void;
}

export const FindLiveClassButton = ({ onClick }: FindLiveClassButtonProps) => {
  const __ = useTranslation().t;
  const text = __('bookLiveClass');

  return (
    <div onClick={onClick} className="oejr-live-class-btn">
      <Icon name="calendar" />
      {text}
    </div>
  );
};
